<div class='widgets'>
  <ul class='multiplecolumnspan' *ngIf="gebruiksAantallen">
    <app-leermiddeltabel *ngIf="initialized" [gebruik]="gebruiksAantallen"></app-leermiddeltabel>
  </ul>
  <p *ngIf="!initialized">Rapportagegegevens worden opgehaald</p>
  <p *ngIf="!gebruiksAantallen && initialized">Geen resultaten</p>
</div>
